import * as Fermenters from './actions/fermenters'
import * as TankGroups from './actions/tank-groups'
import * as Settings from './actions/settings'
import * as SimulatorSetup from './actions/simulator-setup'
import * as Sites from './actions/sites'
import * as Profiles from './actions/profiles'
import * as Ferments from './actions/ferments'
import * as App from './actions/app'
import * as User from './actions/user'

export {
	Fermenters,
	TankGroups,
	Settings,
	SimulatorSetup,
	Sites,
	Profiles,
	Ferments,
	App,
	User
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js